import React, {
	useEffect,
	useState,
	forwardRef,
	useImperativeHandle,
} from "react";
import moment from "moment";
import _ from "lodash";
import { inputValidationChecks } from "../../../utils/formValidation";
import SelectDatePicker from "@netojose/react-select-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SelectDate = forwardRef((props, ref) => {
	const {
		val,
		setVal,
		label = "",
		classInput = "",
		classLabel = "",
		validation = "",
		minDate = "",
		maxDate = "",
	} = props;

	useImperativeHandle(ref, () => {
		return {
			validateInput: validateInput,
		};
	});

	const [submitted, setSubmitted] = useState(false);
	const [error, setError] = useState("");

	const handleUserInput = (date) => {
		//setVal(date);
		setVal(moment(date).format("YYYY-MM-DD"));
		if (submitted) {
			validateInput(date);
		}
	};

	const validateInput = (value = null) => {
		let errors = false;
		if (value) {
			errors = inputValidationChecks(value, validation, setError);
		} else {
			errors = inputValidationChecks(val, validation, setError);
			setSubmitted(true);
		}
		return errors;
	};

	return (
		<>
			<label htmlFor="formGroupExampleInput" className={classLabel}>
				{label}
			</label>
			<SelectDatePicker
				value={val}
				className={
					"col-11 date-picker pl-0 pr-5" +
					`${error === "" ? "" : " is-invalid"}`
				}
				onDateChange={(date) => handleUserInput(date)}
				ref={ref}
				minDate={minDate}
				maxDate={maxDate}
			/>
			{error && <div className="invalid-date">{error}</div>}
		</>
	);
});

export default SelectDate;
